import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import authHeader from "./auth_header";
import * as CONST from './common'

const API_URL = CONST.API_URL;
const AUTH_URL = CONST.API_AUTH_URL


const register = (first_name, last_name, email, password, botcode) => {
  return axios.post(AUTH_URL + "register", {
    first_name,
    last_name,
    email,
    password,
    botcode,
  });
};

const login = (email, password) => {
  const params = new URLSearchParams();
  params.append('username', email);
  params.append('password', password);

  return axios
    .post(AUTH_URL + "jwt/login",
      params,
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', "Access-Control-Allow-Origin": "*" }
      }
    )
    .then((response) => {
      if (response.data.access_token) {
        secureLocalStorage.setItem("token", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  secureLocalStorage.removeItem("token");
  secureLocalStorage.removeItem("user");
  return Promise.resolve()
};


const requestNewPassword = (email) => {
  return axios.post(AUTH_URL + 'forgot-password', {
    email: email
  }).then((response) => {
    return response.data;
  })
}

const resetPassword = (token, password) => {
  return axios.post(AUTH_URL + 'reset-password', {
    token: token,
    password: password
  }).then((response) => {
    return response.data;
  })
}

const changePassword = (oldPassword, newPassword, confirmPassword) => {
  return axios.post(API_URL + 'change_password', {
    current_password: oldPassword,
    new_password: newPassword,
    confirm_password: confirmPassword
  }, { headers: authHeader() }).then((response) => {
    return response.data;
  })
}

const getGoogleAuth = () => {
  return axios.get(AUTH_URL + 'google/authorize');
}

const getGoogleCallback = (query) => {
  return axios.get(AUTH_URL + 'google/callback?' + query).then((response) => {
    if (response.data.access_token) {
      secureLocalStorage.setItem("token", JSON.stringify(response.data));
    }
    return response.data;
  });
}

export default {
  register,
  login,
  logout,
  changePassword,
  requestNewPassword,
  resetPassword,
  getGoogleAuth,
  getGoogleCallback
};